export { default as useProductsMaterialsFilter } from './useProductsMaterialsFilter';
